import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc } from 'firebase/firestore';
import { db } from './firebaseConfig';

// Initialize Firebase Messaging
let messaging = null;

export const initializeMessaging = (app) => {
  try {
    messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    console.error('Error initializing messaging:', error);
    return null;
  }
};

// Request notification permission and get FCM token
export const requestNotificationPermission = async (userId) => {
  console.log('=== REQUESTING NOTIFICATION PERMISSION ===', { userId });
  try {
    // Check if browser supports notifications
    if (!('Notification' in window)) {
      console.error('❌ This browser does not support notifications');
      return null;
    }

    // Check if service worker is supported
    if (!('serviceWorker' in navigator)) {
      console.error('❌ Service workers are not supported');
      return null;
    }

    // Check current permission status
    console.log('Current notification permission:', Notification.permission);

    // Request permission
    const permission = await Notification.requestPermission();
    console.log('Permission result:', permission);
    
    if (permission === 'granted') {
      console.log('✅ Notification permission granted');
      
      if (!messaging) {
        console.error('❌ Messaging not initialized');
        return null;
      }

      console.log('Getting FCM token...');
      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: 'BKf5mpEld8sBatCLGoqdzHQ4TPqnfR-LQ9Li2MWnPnYf6gUIx84Cs0ORj4IwTnhF3ixP1NDXOuEQNQh_8ut_c9Y'
      });

      if (token) {
        console.log('✅ FCM Token received:', token.substring(0, 20) + '...');
        
        // Save token to Firestore for this user
        if (userId) {
          console.log('Saving token to Firestore for user:', userId);
          await saveTokenToFirestore(userId, token);
          console.log('✅ Token saved successfully');
        } else {
          console.error('❌ No userId provided, cannot save token');
        }
        
        return token;
      } else {
        console.error('❌ No registration token available');
        return null;
      }
    } else if (permission === 'denied') {
      console.error('❌ Notification permission DENIED by user');
      return null;
    } else {
      console.error('❌ Notification permission DEFAULT (user dismissed prompt)');
      return null;
    }
  } catch (error) {
    console.error('❌ Error requesting notification permission:', error);
    console.error('Error details:', error.message, error.code);
    return null;
  }
};

// Save FCM token to Firestore
const saveTokenToFirestore = async (userId, token) => {
  console.log('=== SAVING TOKEN TO FIRESTORE ===');
  console.log('UserId:', userId);
  console.log('Token:', token.substring(0, 20) + '...');
  try {
    const tokenRef = doc(db, 'users', userId);
    console.log('Firestore path:', `users/${userId}`);
    await setDoc(tokenRef, {
      fcmToken: token,
      tokenUpdatedAt: new Date()
    }, { merge: true });
    console.log('✅ FCM token saved to Firestore successfully');
  } catch (error) {
    console.error('❌ Error saving token to Firestore:', error);
    console.error('Error code:', error.code);
    console.error('Error message:', error.message);
  }
};

// Listen for foreground messages
export const onMessageListener = () => {
  return new Promise((resolve) => {
    if (!messaging) {
      console.error('Messaging not initialized');
      return;
    }

    onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      resolve(payload);
    });
  });
};

// Show a local notification (for foreground messages)
export const showLocalNotification = (title, body, options = {}) => {
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification(title, {
      body,
      icon: '/manifest.json', // Add your icon path
      badge: '/manifest.json',
      ...options
    });
  }
};
